import React from "react";
import { currencyDisplay } from "../../../utils/helpers";
import { CruiseCabin, CruiseDeparture, CruiseRoomType } from "../../../interfaces/itinerary.interface";

const CruiseCabinSelectorV3 = (props: {
  departure?: CruiseDeparture;
  priceCurrency: string;
  selectedMultiplier?: number;
  selectedTourId?: number;
  onSelectRoomType: (roomType: CruiseRoomType) => void;
  onSelectCabin: (cabin: CruiseCabin) => void;
  cabinSelectionDisabled?: boolean;
}) => {
  const { departure, priceCurrency, selectedMultiplier, selectedTourId, onSelectRoomType, onSelectCabin, cabinSelectionDisabled } = props;

  if (!departure) return null;

  const roomTypes = departure.room_types || [];
  const selectedRoomType = roomTypes.find((rt) => rt.multiplier === selectedMultiplier);

  return (
    <div className="cruise-selector-v3">
      <span className="cruise-selector-v3_label">Please Choose a Room Type</span>
      <div className="cruise-selector-v3_room-types">
        {roomTypes.map((roomType) => {
          const isLoadingThisRoom = roomType.multiplier === selectedMultiplier && cabinSelectionDisabled;
          return (
          <button
            type="button"
            key={roomType.multiplier}
            disabled={cabinSelectionDisabled}
            className={`cruise-selector-v3_room-pill ${roomType.multiplier === selectedMultiplier ? "selected" : ""} ${isLoadingThisRoom ? "loading" : ""}`}
            onClick={() => !cabinSelectionDisabled && onSelectRoomType(roomType)}
          >
            {roomType.label}
          </button>
          );
        })}
      </div>

      {selectedRoomType && (
        <>
          <span className="cruise-selector-v3_label">Cabin Type</span>
          <div className="cruise-selector-v3_cabins">
            {selectedRoomType.cabins.map((cabin) => {
              const selected = cabin.tour_id === selectedTourId;
              const locked = !cabin.available || (cabinSelectionDisabled && !selected);
              const isLoadingThisCabin = selected && cabinSelectionDisabled;
              return (
                <div
                  key={cabin.tour_id}
                  className={`cruise-selector-v3_cabin ${selected ? "selected" : ""} ${locked ? "disabled" : ""} ${isLoadingThisCabin ? "loading" : ""}`}
                  onClick={() => cabin.available && !cabinSelectionDisabled && onSelectCabin(cabin)}
                >
                  <div className="cruise-selector-v3_cabin-info">
                    <span className="cruise-selector-v3_cabin-label">{cabin.label}</span>
                    <span className="cruise-selector-v3_cabin-price">
                      {cabin.available ? `From ${currencyDisplay(priceCurrency, cabin.from_price)}` : "Sold out"}
                    </span>
                  </div>
                  <div className={`radio${selected ? " radio--selected" : ""}`}>
                    {selected && <div className="radio_dot" />}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default CruiseCabinSelectorV3;
